import { debounce } from '@github/mini-throttle';
export const isMobile = ()=>{
    if (typeof window === 'undefined') {
        return false // Ensure SSR safety
        ;
    }
    return window.innerWidth <= 1024;
};
export const onResize = (callback, delay = 200)=>{
    if (typeof window !== 'undefined') {
        const debouncedCallback = debounce(callback, delay);
        window.addEventListener('resize', debouncedCallback);
        return ()=>window.removeEventListener('resize', debouncedCallback);
    }
};
